// components/GlobalSessionWarning.js
import React from 'react';
import { useSession } from '../context/SessionContext';
import './GlobalSessionWarning.scss';

const GlobalSessionWarning = () => {
  const { 
    showWarning, 
    timeLeft, 
    seconds, 
    extendSession, 
    logout 
  } = useSession();

  if (!showWarning) return null;

  return (
    <div className="session-modal-overlay">
      <div className="session-modal">
        <div className="session-modal-header">
          <h5>⚠️ Session Expiring Soon</h5>
          <i className="fas fa-clock text-warning"></i>
        </div>
        
        <div className="session-modal-body">
          <p>Your session will expire in:</p>
          <div className="countdown-timer">
            <span className="time-display">
              {timeLeft}:{seconds.toString().padStart(2, '0')}
            </span>
          </div>
          <p>Do you want to continue your session?</p>
        </div>
        
        <div className="session-modal-footer">
          <button 
            className="btn btn-secondary" 
            onClick={logout}
          >
            <i className="fas fa-sign-out-alt me-2"></i>
            Logout
          </button>
          <button 
            className="btn btn-primary" 
            onClick={extendSession}
          >
            <i className="fas fa-refresh me-2"></i>
            Continue Session
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlobalSessionWarning;